import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexMikrotikProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class IndexMikrotik extends React.Component<IndexMikrotikProps> {

    @observable private routers: any[] = [];
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/mikrotik_router/read').then((response) => {
            this.routers = response.data.response;
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando routers MikroTik");
            this.isLoaded = true;
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de routers</h4>
                                <p className="card-category">Routers MikroTik registrados</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("MikroTik.add") &&
                                            <Link to={`/mikrotik/nuevo`}>
                                                <button className="btn btn-info btn-lg pull-right">
                                                    <i className="material-icons">router</i> Nuevo
                                                    <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>Nombre</th>
                                                <th>IP</th>
                                                <th>Usuario</th>
                                                <th>Estado</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.routers.map((router: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{router.name != null && router.name !== "" ? router.name : router.nombre}</td>
                                                                <td>{router.ip}</td>
                                                                <td>{router.username != null && router.username !== "" ? router.username : router.usuario}</td>
                                                                <td>
                                                                    {Number(router.status) === 1 ? (
                                                                        <i className="material-icons text-success">check_circle</i>
                                                                    ) : (
                                                                        <i className="material-icons text-danger">cancel</i>
                                                                    )}
                                                                </td>
                                                                <td className="td-actions text-right">
                                                                    {sessionService.canViewSection("MikroTik.view") &&
                                                                        <Link to={`/mikrotik/ver/${router.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                                <i className="material-icons">visibility</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {sessionService.canViewSection("MikroTik.edit") &&
                                                                        <Link to={`/mikrotik/${router.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                <i className="material-icons">edit</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {sessionService.canViewSection("MikroTik.delete") &&
                                                                        <button onClick={() => this.deleteRouter(router.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                            <i className="material-icons">close</i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteRouter = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estás seguro que quieres borrar este router?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/mikrotik_router/delete`, deleteObject)
                        .then((response) => {
                            this.routers.splice(index, 1);
                            toast.success("Router borrado correctamente");
                        }).catch((error) => {
                            toast.error("Error borrando router");
                        })
                }
            });
    }
}
